const cnpjValidation = ({ cnpj, emptyCnpj, incorrectCnpj }) => {
    cnpj = cnpj.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

    let tamanho;
    let numeros;
    let digitos;
    let resultado;
    let soma;
    let pos;
    let i;

    if (cnpj === "")
        return {
            message: emptyCnpj,
            status: "notOk"
        };

    if (cnpj.length !== 14)
        return {
            message: incorrectCnpj,
            status: "notOk"
        };

    const invalidosConhecidos = [
        "00000000000000", "11111111111111", "22222222222222", 
        "33333333333333", "44444444444444", "55555555555555", 
        "66666666666666", "77777777777777", "88888888888888", "99999999999999"
    ];
    if (invalidosConhecidos.includes(cnpj))
        return { message: incorrectCnpj, status: "notOk" };

    tamanho = cnpj.length - 2;
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    
    if (isNaN(Number(digitos))) {
        return { message: incorrectCnpj, status: "notOk" };
    }

    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        let charValue = numeros.charCodeAt(tamanho - i) - 48;
        soma += charValue * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== Number(digitos.charAt(0)))
        return { message: incorrectCnpj, status: "notOk" };

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        let charValue = numeros.charCodeAt(tamanho - i) - 48;
        soma += charValue * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== Number(digitos.charAt(1)))
        return { message: incorrectCnpj, status: "notOk" };

    return {
        message: "",
        status: "ok"
    };
};

export { cnpjValidation };